<template>

  <div class="tw-bg-blue-light">
    <v-form
        class="tw-py-12 tw-flex tw-flex-col tw-gap-12 limiter"
        ref="form"
        v-model="valid"
        lazy-validation
    >

      <h4 class="tw-text-5xl">
        Connexion
      </h4>

      <div class="tw-grid tw-gap-8 md:tw-grid-cols-2">

        <v-text-field
            v-model="email"
            :rules="[rules.email]"
            label="E-mail"
            prepend-icon="mdi-email-outline"

        ></v-text-field>

        <v-text-field
            v-model="password"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required]"
            :type="show1 ? 'text' : 'password'"
            name="input-10-1"
            label="Mot de passe"
            counter
            @click:append="show1 = !show1"
        ></v-text-field>

      </div>

      <div class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-gap-12 md:tw-items-center">
        <v-btn
            color="primary"
            @click="login"
        >
          Connexion
        </v-btn>

        <div class="tw-w-full tw-items-center tw-flex tw-gap-8" v-if="sending">
          <v-progress-linear
              class="tw-w-96"
              color="primary accent-4"
              rounded
              height="6"
              indeterminate
          ></v-progress-linear>
          <span class="tw-block text-1-5">Connexion en cours</span>
        </div>
        <span class="tw-block text-1-5" v-if="error"><v-icon color="primary" left>mdi-alert-circle-outline</v-icon>Identifiant ou mot de passe incorrect</span>
      </div>

      <div class="tw-w-full tw-items-center tw-flex tw-flex-col md:tw-flex-row tw-gap-8">
        <v-btn color="primary" @click="lostPassword">
          Mot de passe oublié
        </v-btn>
        <span v-if="!passwordReset" class="tw-block text-1-5">Renseignez votre adresse mail dans le champ ci-dessus</span>
        <span v-else class="tw-block text-1-5">Un mail de réinitialisation de mot de passe vous a été envoyé</span>
      </div>

    </v-form>
  </div>

</template>

<script>
import store from "../../store";
import axios from "axios"

export default {
  name: "LoginForm",

  data: () => ({
    valid: false,
    sending : false,
    sent : false,
    show1: false,
    error : false,
    passwordReset : false,

    // values

    // - Infos principales
    email: '',
    password: '',


    // rules
    rules: {
      required: value => !!value || 'Mot de passe requis',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'E-mail non valide.'
      },
    },
  }),
  methods: {
    lostPassword() {
      if (!this.email) return false
      const url = store.state.baseJson+'/simple-jwt-login/v1/user/reset_password'
      const data =  {
        "email": this.email,
        "AUTH_KEY": "EdaSceneDenfanceAuthKey123"
      }
      axios.post(url , data).then( () => {
        this.passwordReset = true
      } )
    },
    login() {
      this.sending = true
      const url = store.state.baseJson+'/simple-jwt-login/v1/auth'
      const data =  {
        "email": this.email,
        "password": this.password,
        "AUTH_KEY": "EdaSceneDenfanceAuthKey123"
      }
      axios.post(url , data).then( (res) => {
        this.validateAuth(res.data.data.jwt)
      } ).catch( () => {
        this.sending = false
        this.error = true
      })
    },
    validateAuth(jwt) {
      const url = store.state.baseUrl+'/?rest_route=/simple-jwt-login/v1/auth/validate&JWT='+jwt
      axios.get(url).then( (res) => {
        const user = res.data.data.user
        store.commit('setUser' , user)
        store.commit('setToken' , jwt)
        this.sending = false
      } ).catch( () => {
        this.sending = false
        this.error = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>